import {ICommandeFormationWebServiceClient} from "@resources/resources";
import {
  CommandeFormationDto,
  FormationDto,
  OrganismeCommanditaireDto,
  SaveCommandeFormationDto,
  SaveParticipantFormationDto
} from "@common/resources/resources";
import {Injectable} from "@angular/core";
import * as lodash from "lodash";

@Injectable()
export class CommandeFormationStore {

  private commandeFormation: CommandeFormationDto;
  private saveCommandeFormation: SaveCommandeFormationDto;
  private formations: Array<FormationDto>;

  constructor(private commandeFormationWebServiceClient: ICommandeFormationWebServiceClient) {
    this.initializeSaveCommandeFormation();
    this.initializeFormations();
    this.initializeCommandeFormation();
  }

  initializeCommandeFormation() {
    let lcf = sessionStorage.getItem('commandeFormation');
    this.commandeFormation = JSON.parse(lcf);
  }

  initializeSaveCommandeFormation() {
    let lsc = sessionStorage.getItem('saveCommandeFormation');
    console.log("lsc:" + lsc);
    this.saveCommandeFormation = JSON.parse(lsc);
    if (this.saveCommandeFormation === null) {
      let saveCommandeFormation = new SaveCommandeFormationDto();
      saveCommandeFormation.participants = new Array<SaveParticipantFormationDto>();
      saveCommandeFormation.participants.push(new SaveParticipantFormationDto());
      saveCommandeFormation.organismeCommanditaire = new OrganismeCommanditaireDto();
      this.setSaveCommandeFormation(saveCommandeFormation);
    }
  }

  initializeFormations() {
    let lsf = sessionStorage.getItem("formations");
    console.log("lsf:" + lsf);
    this.formations = JSON.parse(lsf);
    if (this.formations == null) {
      this.formations = new Array();
      sessionStorage.setItem('formations', JSON.stringify(this.formations));
    }
  }

  private setSaveCommandeFormation(saveCommandeFormation: SaveCommandeFormationDto) {
    this.saveCommandeFormation = saveCommandeFormation;
    sessionStorage.setItem('saveCommandeFormation', JSON.stringify(this.saveCommandeFormation));
  }

  private setFormations(formations: Array<FormationDto>) {
    // modification liste formation
    this.formations = formations;
    // modification commande
    this.saveCommandeFormation.formationIds = lodash.map(this.formations, formation => {
      return formation.id;
    });
    // modification participant
    lodash.forEach(this.saveCommandeFormation.participants, participant => {
      participant.formationIds = this.saveCommandeFormation.formationIds;
    });
    sessionStorage.setItem('saveCommandeFormation', JSON.stringify(this.saveCommandeFormation));
    sessionStorage.setItem('formations', JSON.stringify(this.formations));
  }

  addFormations(formations: Array<FormationDto>) {
    let newFormations = new Array<FormationDto>();
    formations.forEach(formation => {
      let foundFormation = this.getFormationById(formation.id);
      if (foundFormation == null) {
        this.formations.push(formation);
        newFormations.push(formation);
      }
    });
    this.saveCommandeFormation.formationIds = lodash.map(this.formations, formation => {
      return formation.id;
    });
    if (newFormations.length > 0) {
      if (this.saveCommandeFormation.participants != null) {
        lodash.forEach(this.saveCommandeFormation.participants, participant => {
          if (participant.formationIds == null) {
            participant.formationIds = new Array<number>();
          }
          lodash.forEach(newFormations, newFormation => {
            participant.formationIds.push(newFormation.id);
          });
        });
      }
    }
    sessionStorage.setItem('saveCommandeFormation', JSON.stringify(this.saveCommandeFormation));
    sessionStorage.setItem('formations', JSON.stringify(this.formations));
  }

  countFormations(): number {
    return this.formations != null ? this.formations.length : 0;
  }

  getFormations(): Array<FormationDto> {
    return this.formations;
  }

  getFormation(index: number): FormationDto {
    return this.formations[index];
  }

  getFormationById(id: number) {
    let formation = lodash.find(this.formations, formation => {
      if (formation.id == id) {
        return true;
      } else {
        return false;
      }
    });
    return formation;
  }

  setOrganismeCommanditaire(organismeCommanditaire: OrganismeCommanditaireDto) {
    this.saveCommandeFormation.organismeCommanditaire = organismeCommanditaire;
    sessionStorage.setItem('saveCommandeFormation', JSON.stringify(this.saveCommandeFormation));
  }

  getOrganismeCommanditaire(): OrganismeCommanditaireDto {
    return this.saveCommandeFormation.organismeCommanditaire;
  }

  getParticipantFormations(): Array<SaveParticipantFormationDto> {
    return this.saveCommandeFormation.participants;
  }

  countParticipantFormations(): number {
    return this.saveCommandeFormation.participants.length;
  }

  addParticipantFormation(saveParticipantFormation: SaveParticipantFormationDto) {
    saveParticipantFormation.formationIds = new Array<number>();
    lodash.forEach(this.saveCommandeFormation.formationIds, formationId => {
      saveParticipantFormation.formationIds.push(formationId);
    });
    this.saveCommandeFormation.participants.push(saveParticipantFormation);
    sessionStorage.setItem('saveCommandeFormation', JSON.stringify(this.saveCommandeFormation));
  }

  setParticipantFormation(saveParticipantFormation: SaveParticipantFormationDto, index: number) {
    saveParticipantFormation.formationIds = new Array<number>();
    lodash.forEach(this.saveCommandeFormation.formationIds, formationId => {
      saveParticipantFormation.formationIds.push(formationId);
    });
    this.saveCommandeFormation.participants[index] = saveParticipantFormation;
    sessionStorage.setItem('saveCommandeFormation', JSON.stringify(this.saveCommandeFormation));
  }

  getParticipantFormation(index: number): SaveParticipantFormationDto {
    return this.saveCommandeFormation.participants[index];
  }

  removeParticipantFormation(index: number) {
    this.saveCommandeFormation.participants.splice(index, 1);
    sessionStorage.setItem('saveCommandeFormation', JSON.stringify(this.saveCommandeFormation));
  }

  removeFormationForParticipantFormation(indexParticipant: number, idFormation: number) {
    this.saveCommandeFormation.participants[indexParticipant].formationIds = lodash.filter(
      this.saveCommandeFormation.participants[indexParticipant].formationIds,
      formationId => {
        if (formationId != idFormation) {
          return true;
        } else {
          return false;
        }
      });
    sessionStorage.setItem('saveCommandeFormation', JSON.stringify(this.saveCommandeFormation));
  }

  getSaveCommandeFormation(): SaveCommandeFormationDto {
    return this.saveCommandeFormation;
  }

  setCommandeFormation(commandeFormation: CommandeFormationDto) {
    this.commandeFormation = commandeFormation;
    sessionStorage.setItem('commandeFormation', JSON.stringify(this.commandeFormation));
  }

  getCommandeFormation(): CommandeFormationDto {
    return this.commandeFormation;
  }

  hasCommandeFormation(): boolean {
    return this.commandeFormation != null;
  }

  isCommandeFormationPayee(): boolean {
    let result = false;
    if (this.hasCommandeFormation()) {
      if (this.commandeFormation.etat == 'PAYEE') {
        result = true;
      }
    }
    return result;
  }

  emptySaveCommandeFormation() {
    sessionStorage.removeItem('saveCommandeFormation');
    sessionStorage.removeItem('formations');
    this.initializeSaveCommandeFormation();
    this.initializeFormations();
  }

  emptyCommandeFormation(mustDelete: boolean) {
    if (mustDelete && this.commandeFormation != null && this.commandeFormation.id != null) {
      this.commandeFormationWebServiceClient.deleteCommandeFormation(this.commandeFormation.id, {notFinish: true}).subscribe();
    }
    this.commandeFormation = null;
    sessionStorage.removeItem('commandeFormation');
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/common/store/commande-formation.store.ts